import { render, staticRenderFns } from "./ScheduledTournamentModule.vue?vue&type=template&id=0fd4bb4b&"
import script from "./ScheduledTournamentModule.vue?vue&type=script&lang=js&"
export * from "./ScheduledTournamentModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports